module.exports = __webpack_public_path__ + "static/deck-c757ce16babd267c8d461dfe09cf8dd8.jpeg";